
<template>
  <div class="project" id="portfolio">
	<div class="container">
		<div class="page_title">
				<h1>Project</h1>
			</div>
		<div class="wrapper">
			
			<div class="content">
				<div class="p_item">
					<div class="social">
						<!-- svelte-ignore a11y-missing-attribute -->
						<span
							><a href="https://monabbirhasan.github.io/berger_shop_static/"
								><img src="https://img.icons8.com/ios-filled/50/null/domain.png" width="30" /></a
							></span
						>
						<!-- svelte-ignore a11y-missing-attribute -->
						<span
							><a href="https://github.com/MonabbirHasan/berger_shop_static"
								><img src="https://img.icons8.com/ios-filled/50/null/github.png" width="30" /></a
							></span
						>
					</div>
					<div>
						<div class="project_img">
							<img src="../assets/portfolio_img/berger.png" class="img-fluid" alt="full-stack developer in asia" />
						</div>
						<div class="details">
							<h3>mearn stack grocery website</h3>
							<p>
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet, ea exercitationem
								totam quam deserunt accusantium
							</p>
							<div class="language_use">
								<h4>html5</h4>
								<h4>css3</h4>
								<h4>bootstrap</h4>
								<h4>JavaScript</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="p_item">
					<div class="social">
						<!-- svelte-ignore a11y-missing-attribute -->
						<span
							><a href="https://monabbirhasan.github.io/gargo-static/"
								><img src="https://img.icons8.com/ios-filled/50/null/domain.png" width="30" /></a
							></span
						>
						<!-- svelte-ignore a11y-missing-attribute -->
						<span
							><a href="https://github.com/MonabbirHasan/gargo-static"
								><img src="https://img.icons8.com/ios-filled/50/null/github.png" width="30" /></a
							></span
						>
					</div>
					<div>
						<div class="project_img">
							<img src="../assets/portfolio_img/gargo.png" height="300px" class="img-fluid" alt="full-stack developer in asia" />
						</div>
						<div class="details">
							<h3>mearn stack grocery website</h3>
							<p>
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet, ea exercitationem
								totam quam deserunt accusantium
							</p>
							<div class="language_use">
								<h4>html5</h4>
								<h4>css3</h4>
								<h4>bootstrap</h4>
								<h4>JavaScript</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="p_item">
					<div class="social">
						<!-- svelte-ignore a11y-missing-attribute -->
						<span
							><a href="/"
								><img src="https://img.icons8.com/ios-filled/50/null/domain.png" width="30" /></a
							></span
						>
						<!-- svelte-ignore a11y-missing-attribute -->
						<span
							><a href="/"
								><img src="https://img.icons8.com/ios-filled/50/null/github.png" width="30" /></a
							></span
						>
					</div>
					<div>
						<div class="project_img">
							<img src="../assets/portfolio_img/investco.png" class="img-fluid" alt="full-stack developer in asia" />
						</div>
						<div class="details">
							<h3>mearn stack grocery website</h3>
							<p>
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet, ea exercitationem
								totam quam deserunt accusantium
							</p>
							<div class="language_use">
								<h4>html5</h4>
								<h4>css3</h4>
								<h4>bootstrap</h4>
								<h4>JavaScript</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="p_item">
					<div class="social">
						<!-- svelte-ignore a11y-missing-attribute -->
						<span
							><a href="https://monabbirhasan.github.io/martin_static/"
								><img src="https://img.icons8.com/ios-filled/50/null/domain.png" width="30" /></a
							></span
						>
						<!-- svelte-ignore a11y-missing-attribute -->
						<span
							><a href="https://github.com/MonabbirHasan/martin_static"
								><img src="https://img.icons8.com/ios-filled/50/null/github.png" width="30" /></a
							></span
						>
					</div>
					<div>
						<div class="project_img">
							<img src="../assets/portfolio_img/martin.png" class="img-fluid" alt="full-stack developer in asia" />
						</div>
						<div class="details">
							<h3>mearn stack grocery website</h3>
							<p>
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet, ea exercitationem
								totam quam deserunt accusantium
							</p>
							<div class="language_use">
								<h4>html5</h4>
								<h4>css3</h4>
								<h4>bootstrap</h4>
								<h4>JavaScript</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="p_item">
					<div class="social">
						<!-- svelte-ignore a11y-missing-attribute -->
						<span
							><a href="https://monabbirhasan.github.io/metaportal/"
								><img src="https://img.icons8.com/ios-filled/50/null/domain.png" width="30" /></a
							></span
						>
						<!-- svelte-ignore a11y-missing-attribute -->
						<span
							><a href="https://github.com/MonabbirHasan/metaportal"
								><img src="https://img.icons8.com/ios-filled/50/null/github.png" width="30" /></a
							></span
						>
					</div>
					<div>
						<div class="project_img">
							<img src="../assets/portfolio_img/metaportal.png" class="img-fluid" alt="full-stack developer in asia" />
						</div>
						<div class="details">
							<h3>mearn stack grocery website</h3>
							<p>
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet, ea exercitationem
								totam quam deserunt accusantium
							</p>
							<div class="language_use">
								<h4>html5</h4>
								<h4>css3</h4>
								<h4>bootstrap</h4>
								<h4>JavaScript</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="p_item">
					<div class="social">
						<!-- svelte-ignore a11y-missing-attribute -->
						<span
							><a href="https://monabbirhasan.github.io/FantasyFocus.com/"
								><img src="https://img.icons8.com/ios-filled/50/null/domain.png" width="30" /></a
							></span
						>
						<!-- svelte-ignore a11y-missing-attribute -->
						<span
							><a href="https://github.com/MonabbirHasan/FantasyFocus.com"
								><img src="https://img.icons8.com/ios-filled/50/null/github.png" width="30" /></a
							></span
						>
					</div>
					<div>
						<div class="project_img">
							<img src="../assets/portfolio_img/movie.png" class="img-fluid" alt="full-stack developer in asia" />
						</div>
						<div class="details">
							<h3>mearn stack grocery website</h3>
							<p>
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet, ea exercitationem
								totam quam deserunt accusantium
							</p>
							<div class="language_use">
								<h4>html5</h4>
								<h4>css3</h4>
								<h4>bootstrap</h4>
								<h4>JavaScript</h4>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

</template>

<script>
export default {
name:"project-page"
}
</script>


<style>
	.project {
		padding: 10px;
		width: 100%;
	}
	.page_title {
		padding: 10px;
		text-align: left;
		border-bottom:4px solid #fc9;
		display: inline-block;
		margin-left: 20px;
		border-radius: 5px;
	}
	.page_title h1 {
		font-size:2.5rem;
		font-weight: 900;
		color: black;
		display: inline-block;
		text-transform: uppercase;
		text-transform: uppercase;
		background: -webkit-linear-gradient(#f0ff, #fc9400);
		-webkit-background-clip: text;
		-webkit-text-stroke-color: #fc9;
		-webkit-text-stroke-width: 1px;
		-webkit-text-fill-color: transparent;
		background-image:url("https://media.giphy.com/media/xT1XGZndeDLlWvSDaU/giphy.gif");
		animation: text 1s linear initial;
		background-position: center;
		background-size: cover;
		/* padding: 0 10px; */
	}
	.project .content {
		padding: 50px;
		display: grid;
		gap: 25px;
		grid-template-columns: auto auto auto;
		justify-content: center;
		align-items: center;
	}
	.content .p_item {
		padding: 15px;
		border-radius: 5px;
		position: relative;
		background: #fc9;
		z-index: 10000;
		box-shadow: -2px -2px 5px #eee, 2px 2px 5px #eee;
		display: inline-block;
		transition: 0.4s;
	}
	.content .p_item::after {
		content: '';
		width: 0%;
		transition: 0.4s;
		height: 0%;
		position: absolute;
		top: 0;
		left: 0;
		background: #fff;
		z-index: -999;
	}
	.content .p_item:hover::after {
		width: 100%;
		right: 0 !important;
		filter: drop-shadow(5px 5px 10px #eee);
		height: 100%;
	}
	.p_item .project_img {
		height: 300px;
		overflow: hidden;
	}
	.p_item .project_img img {
		filter: drop-shadow(0) !important;
		box-shadow: 0 !important;
		transition: 10s;
	}
	.p_item .project_img:hover img{
		transform:translateY(-100%)
	}
	.p_item .social {
		padding: 5px;
		display: flex;
		justify-content: space-between;
	}
	img {
		filter: drop-shadow(0) !important;
		box-shadow: 0 !important;
	}
	.p_item .social span a {
		font-size: 1.8rem;
		color: #000;
	}
	.p_item .social span a:hover {
		color: #fff;
		filter: hue-rotate(300deg);
	}
	.content .p_item .details {
		padding: 20px 0;
	}
	.content .p_item .details h3 {
		text-transform: capitalize;
		font-weight: bold;
		font-size: 16px;
		color: #000;
	}
	.content .p_item .details p {
		display: inline-block;
		word-wrap: break-word;
	}
	.content .p_item .language_use {
		padding: 10px 0;
		display: grid;
		grid-template-columns: auto auto auto auto;
	}
	.content .p_item .language_use h4 {
		text-transform: capitalize;
		font-weight: 400;
		font-size: 14px;
		background: #000;
		padding: 5px;
		margin: 5px;
		color: white;
		border-radius: 5px;
	}
</style>
